<template>
    <el-container id="app">
        <el-aside width="250px" style="overflow:unset">
            <span :class="'env env-'+env">{{env}}</span>
            <img draggable="false" class="logo" src="static/STS-header-logo.png" alt="HARDT logo" />
            
            <navigation @place-order="showPlaceOrderDialog" @new-claim="showNewClaimDialog" @new-service-ticket="showCreateServiceTicketDialog" @register-equipment="showRegisterEquipmentDialog"></navigation>
        </el-aside>
        <el-container>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <create-update-part-order-dialog :visible="orderDialogVisible" @dialogClosed="orderDialogVisible = false"></create-update-part-order-dialog>
        <create-update-claim-dialog :visible="claimDialogVisible" @dialogClosed="claimDialogVisible = false"></create-update-claim-dialog>
        <equipment-registration-dialog :equipmentId="equipmentId" :visible="registerEquipmentDialogVisible" @dialogClosed="equipmentDialogClose"></equipment-registration-dialog>
        <create-service-ticket-dialog :visible="createServiceTicketDialogVisible" @dialogClosed="createServiceTicketDialogVisible = false"></create-service-ticket-dialog>
        <create-update-customer-dialog :visible="customerCreateDialogVisible" @dialogClosed="customerCreateDialogVisible = false"></create-update-customer-dialog>
        <create-country-dialog :visible="countryCreateDialogVisible" @dialogClosed="countryCreateDialogVisible = false"></create-country-dialog>
    </el-container>
</template>

<script>
    import { EventBus } from "./event-bus.js";
    import Navigation from "./shared/components/Navigation";
    import { CreateUpdateClaimDialog } from "./claims/components";
    import { CreateUpdatePartOrderDialog } from "./orders/components";
    import { EquipmentRegistrationDialog } from "./equipment/components";
    import { CreateServiceTicketDialog } from "./servicetickets/components";
    import { CreateUpdateCustomerDialog } from "./masters/customers/components";
    import { CreateCountryDialog } from "./masters/customers/components";
    import { CostcoServiceRequestsDetailsDialog } from "./costcoservicerequests/components";

    export default {
        name: "app",
        components: {
            Navigation,
            CreateUpdateClaimDialog,
            CreateUpdatePartOrderDialog,
            EquipmentRegistrationDialog,
            CreateServiceTicketDialog,
            CreateUpdateCustomerDialog,
            CreateCountryDialog,
            CostcoServiceRequestsDetailsDialog
        },
        mounted() {
            var self = this;
            EventBus.$on("createCustomer", id => {
                this.customerCreateDialogVisible = true;
            });
            EventBus.$on("editEquipment", equipmentId => {
                this.equipmentId = equipmentId;
                this.registerEquipmentDialogVisible = true;
            });
            EventBus.$on("createCountry", id => {
                this.countryCreateDialogVisible = true;
            });
        },
        data() {
            return {
                claimDialogVisible: false,
                orderDialogVisible: false,
                registerEquipmentDialogVisible: false,
                createServiceTicketDialogVisible: false,
                customerCreateDialogVisible: false,
                equipmentId: undefined,
                countryCreateDialogVisible: false,
                env: location.hostname == 'localhost'?"dev":(location.hostname.split("-").length>1? "test":"prod")
            };
        },
        methods: {
            showPlaceOrderDialog() {
                this.orderDialogVisible = true;
            },
            showNewClaimDialog() {
                this.claimDialogVisible = true;
            },
            showRegisterEquipmentDialog() {
                this.registerEquipmentDialogVisible = true;
            },
            showCreateServiceTicketDialog() {
                this.createServiceTicketDialogVisible = true;
            },
            equipmentDialogClose() {
                this.registerEquipmentDialogVisible = false;
                this.equipmentId = undefined;
            }
        }
    };
</script>

<style>
    body {
        margin: 0;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .logo {
        height: 55px;
        user-select: none;
        margin: 5px 0;
        padding-left: 10px;
    }
    .env {
        position: absolute;
        left: 10px;
        top: 20px;
        background: orange;
        text-align: center;
        border-radius: 30px 30px 30px 30px;
        color: white;
        padding: 5px 10px;
        font-size: 20px;
    }
    .env-prod {
              display:none;
    }


    .pager {
        text-align: right;
        margin-top: 10px;
    }

    /*Custom color for disabled elements and placeholders*/
    .el-textarea.is-disabled .el-textarea__inner, .el-input.is-disabled .el-input__inner,
    .el-cascader.is-disabled .el-cascader__label {
        color: #0052cc !important;
    }

    input::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    input:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    input::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    input:-ms-input-placeholder {
        color: #0052cc !important;
    }

    textarea::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    textarea::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    textarea:-ms-input-placeholder {
        color: #0052cc !important;
    }

    input[type="email"]::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    input[type="email"]:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    input[type="email"]::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    input[type="email"]:-ms-input-placeholder {
        color: #0052cc !important;
    }
    .tablewithshading>.el-table__body-wrapper>table>tbody>tr.el-table__row:nth-child(even)
    {
        background-color: rgba(64,158,255,0.3);
    }
    .el-table .cell
    {
        word-break: break-word;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/App.vue